import React, { useMemo } from 'react';
import { useHistory } from 'react-router-dom';

import { BiometricsType } from '@vestahealthcare/common/enums';
import { translate } from '@vestahealthcare/common/i18n';
import { BiometricsConfig, Patient } from '@vestahealthcare/common/models';

import { Icon } from 'styleguide';

import { DetailItem } from '../utils';

interface Props {
  configs?: BiometricsConfig[];
  member: Patient;
}

export const MemberRPMVendorDetails = ({ configs, member }: Props) => {
  const history = useHistory();

  const goToPage = () => history.push(`/patients/${member.id}/biometrics`);

  const vendors = useMemo(() => {
    const vendorsMap = new Map<string, string[]>();
    configs?.forEach(({ collectionMethod, type }) => {
      const vendor = collectionMethod?.value || '';
      const array = vendorsMap.get(vendor) || [];

      // Merge BP_DIASTOLIC and BP_SYSTOLIC
      if (type === BiometricsType.BP_DIASTOLIC) {
        vendorsMap.set(vendor, [
          ...array,
          translate('personalDetails.bloodPressure'),
        ]);
      } else if (type !== BiometricsType.BP_SYSTOLIC) {
        vendorsMap.set(vendor, [
          ...array,
          translate(`enums.biometricsType.${type.value}`),
        ]);
      }
    });
    return vendorsMap;
  }, [configs]);

  return vendors?.size ? (
    <>
      {[...vendors.keys()].sort().map((key, idx) => (
        <DetailItem
          avoidTranslation
          key={key}
          icon={
            idx === 0 ? (
              <Icon tag="button" className="fa fa-link" onClick={goToPage} />
            ) : undefined
          }
          label={translate(`enums.collectionMethod.${key}`)}
          noMarginBottom={idx === vendors.size - 1}
        >
          {vendors.get(key)?.sort().join(', ')}
        </DetailItem>
      ))}
    </>
  ) : (
    <DetailItem
      namespace="programDetailsCard"
      label="rpmVendor"
      icon={<Icon tag="button" className="fa fa-link" onClick={goToPage} />}
      noMarginBottom
    >
      {member?.riskLevel?.description}
    </DetailItem>
  );
};
